import {
  faChevronLeft,
  faBan,
  faCheck,
} from "@fortawesome/pro-regular-svg-icons";
import Button from "./ToolbarButton";
import { ToolbarWrap, Separator } from "./ToolbarUtils";
import { useEditorContext } from "./EditorContext";
import classNames from "classnames";
import AdaptiveIcon from "@/components/shared/AdaptiveIcon.tsx";

interface LinkToolbarProps {
  linkHref: string;
  setLinkHref: (href: string) => void;
  onBack: () => void;
  onRemoveLink: () => void;
  onAddLink: (href: string) => void;
}

export default function LinkToolbar({
  linkHref,
  setLinkHref,
  onBack,
  onRemoveLink,
  onAddLink,
}: LinkToolbarProps) {
  const { readOnly } = useEditorContext();
  const handleAddLink = () => {
    if (linkHref) {
      onAddLink(
        linkHref.startsWith("http://") || linkHref.startsWith("https://")
          ? linkHref
          : `https://${linkHref}`,
      );
    }
  };
  return (
    <ToolbarWrap>
      <Button
        onClick={onBack}
        tooltip={I18n.t("js.composer.editor.buttons.back_to_toolbar")}
        disabled={readOnly}
      >
        <AdaptiveIcon icon={faChevronLeft} />
      </Button>
      <Separator />
      <div
        className={classNames("flex items-center", {
          "w-full": window.isApp,
        })}
      >
        <input
          type="text"
          value={linkHref}
          onChange={(e) => setLinkHref(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddLink();
            }
          }}
          placeholder={I18n.t(
            "js.composer.editor.buttons.links.placeholder.tooltip",
          )}
          className={classNames(
            "px-2 py-1 border border-gray-300 rounded w-auto! grow",
            { "h-11 text-lg": window.isApp },
          )}
          disabled={readOnly}
        />
        <Button
          onClick={onRemoveLink}
          tooltip={I18n.t("js.composer.editor.buttons.links.abort.tooltip")}
          disabled={readOnly}
        >
          <AdaptiveIcon icon={faBan} />
        </Button>
        <Button
          onClick={handleAddLink}
          tooltip={I18n.t("js.composer.editor.buttons.links.confirm.tooltip")}
          disabled={readOnly}
        >
          <AdaptiveIcon icon={faCheck} />
        </Button>
      </div>
    </ToolbarWrap>
  );
}
